(function () {
  const mobileQuery = window.matchMedia("(max-width: 768px)");

  function cleanText(value) {
    return (value || "").replace(/\s+/g, " ").trim();
  }

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    } else {
      callback();
    }
  }

  function initCollectionIntro() {
    if (!document.body.classList.contains("template-collection")) {
      return;
    }

    const description = document.querySelector(".collection-description");
    if (!description || description.dataset.skMobileCroInit === "true") {
      return;
    }

    description.dataset.skMobileCroInit = "true";

    const toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "sk-mobile-collection-toggle";
    toggle.textContent = "説明をもっと見る";
    toggle.setAttribute("aria-expanded", "false");
    description.insertAdjacentElement("afterend", toggle);

    // Keep the CMS guide readable when the collection introduction is collapsed.
    let guideAnchor = toggle;
    description.querySelectorAll(":scope > .mg-inline-guide").forEach((guide) => {
      guide.classList.add("rte");
      guideAnchor.insertAdjacentElement("afterend", guide);
      guideAnchor = guide;
    });

    function update() {
      const shouldCollapse =
        mobileQuery.matches &&
        (description.scrollHeight > 190 || description.querySelectorAll("a").length >= 8);

      description.classList.toggle("sk-mobile-collection-collapsible", shouldCollapse);
      toggle.hidden = !shouldCollapse;

      if (!shouldCollapse) {
        description.classList.remove("is-expanded");
        toggle.setAttribute("aria-expanded", "false");
        toggle.textContent = "説明をもっと見る";
      }
    }

    toggle.addEventListener("click", () => {
      const isExpanded = description.classList.toggle("is-expanded");
      toggle.setAttribute("aria-expanded", String(isExpanded));
      toggle.textContent = isExpanded ? "説明を閉じる" : "説明をもっと見る";
    });

    window.addEventListener("resize", update);
    requestAnimationFrame(update);
  }

  function getProductAddButton() {
    return document.querySelector(
      '.template-product form[data-type="add-to-cart-form"] button[name="add"]',
    );
  }

  function getProductPriceText() {
    const priceNode = document.querySelector(
      '.template-product [id^="price-"] .price-item-sale, .template-product [id^="price-"] .price-item-regular, .template-product [id^="price-"] .price-requires-login-message',
    );
    return cleanText(priceNode?.textContent);
  }

  function getProductSelectionText() {
    const form = getProductAddButton()?.closest("form");
    const formId = form?.getAttribute("id");
    if (!formId) return "";
    const options = document.querySelectorAll(
      'variant-radios input:checked, variant-selects select',
    );
    return Array.from(options)
      .filter((option) => option.getAttribute("form") === formId)
      .map((option) => cleanText(option.value))
      .filter(Boolean)
      .join(" / ");
  }

  function initProductBar() {
    if (!document.body.classList.contains("template-product")) {
      return;
    }

    const addButton = getProductAddButton();
    if (!addButton || document.querySelector(".sk-mobile-product-bar")) {
      return;
    }

    const bar = document.createElement("div");
    bar.className = "sk-mobile-product-bar";
    bar.setAttribute("aria-live", "polite");
    bar.inert = true;

    const meta = document.createElement("div");
    meta.className = "sk-mobile-product-bar__meta";

    const title = document.createElement("span");
    title.className = "sk-mobile-product-bar__title";
    title.textContent = cleanText(document.querySelector(".product-info-heading")?.textContent);

    const price = document.createElement("span");
    price.className = "sk-mobile-product-bar__price";

    const button = document.createElement("button");
    button.type = "button";
    button.className = "sk-mobile-product-bar__button";

    meta.append(title, price);
    bar.append(meta, button);
    document.body.appendChild(bar);
    document.body.classList.add("sk-mobile-product-bar-ready");

    function needsPlanReview() {
      return Boolean(getProductAddButton()?.closest('form')?.querySelector('[name="selling_plan"]')?.value);
    }

    function updateContent() {
      const currentButton = getProductAddButton();
      const currentLabel = cleanText(currentButton?.querySelector("span")?.textContent);
      const quantity = Number(currentButton?.closest('form')?.elements.namedItem('quantity')?.value || 1);
      const currentPrice = needsPlanReview() ? "定期価格は購入欄で確認" : getProductPriceText() + (quantity > 1 ? " / 1点" : "");
      const selection = getProductSelectionText();
      const productTitle = cleanText(document.querySelector(".product-info-heading")?.textContent);
      const disabled =
        !currentButton ||
        currentButton.disabled ||
        currentButton.getAttribute("aria-disabled") === "true" ||
        currentButton.classList.contains("loading");

      const titleText = (selection ? `選択中：${selection}` : productTitle) + (quantity > 1 ? ` × ${quantity}点` : "");
      const titleLabel = [productTitle, selection].filter(Boolean).join(" — ");
      const buttonText = needsPlanReview() ? "購入欄を見る" : currentLabel || "カートに追加";
      const buttonLabel = [buttonText, productTitle, selection].filter(Boolean).join("、");
      if (price.textContent !== currentPrice) price.textContent = currentPrice;
      if (title.textContent !== titleText) title.textContent = titleText;
      if (title.title !== titleLabel) title.title = titleLabel;
      if (button.textContent !== buttonText) button.textContent = buttonText;
      if (button.getAttribute("aria-label") !== buttonLabel) button.setAttribute("aria-label", buttonLabel);
      if (button.getAttribute("aria-disabled") !== String(disabled)) button.setAttribute("aria-disabled", String(disabled));
    }

    function updateVisibility() {
      const currentButton = getProductAddButton();
      if (!mobileQuery.matches || !currentButton || document.body.classList.contains('sk-mobile-ui-obstructed')) {
        bar.classList.remove("is-visible");
        bar.inert = true;
        return;
      }

      const rect = currentButton.getBoundingClientRect();
      const buttonVisible = rect.top < window.innerHeight - 88 && rect.bottom > 0;
      if (bar.classList.contains("is-visible") === buttonVisible) bar.classList.toggle("is-visible", !buttonVisible);
      if (bar.inert !== buttonVisible) bar.inert = buttonVisible;
    }

    let visibilityPending = false;
    function scheduleVisibility() {
      if (visibilityPending) return;
      visibilityPending = true;
      requestAnimationFrame(() => {
        visibilityPending = false;
        updateVisibility();
      });
    }

    function sync() {
      updateContent();
      scheduleVisibility();
      adjustFloatingWidgets();
    }

    button.addEventListener("click", () => {
      const currentButton = getProductAddButton();
      if (!currentButton) {
        return;
      }
      if (needsPlanReview()) {
        const target = document.querySelector('[data-gosub-product]') || currentButton;
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      if (
        currentButton.disabled ||
        currentButton.getAttribute("aria-disabled") === "true" ||
        currentButton.classList.contains("loading")
      ) {
        const target = document.querySelector("variant-radios, variant-selects") || currentButton;
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      currentButton.click();
    });

    const observer = new MutationObserver(sync);
    const priceNode = document.querySelector('.template-product [id^="price-"]');
    observer.observe(addButton, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["disabled", "aria-disabled", "class"],
    });
    if (priceNode) {
      observer.observe(priceNode, { childList: true, subtree: true });
    }

    document.addEventListener("product:variant-change", sync);
    document.addEventListener("sk-mobile:obstruction-change", scheduleVisibility);
    document.addEventListener("change", (event) => {
      if (event.target.matches('[name="quantity"], [name="selling_plan"]')) sync();
    });
    if (typeof ResizeObserver !== "undefined") {
      new ResizeObserver(() => {
        const height = bar.getBoundingClientRect().height;
        if (height) document.body.style.setProperty("--sk-mobile-bar-height", `${height}px`);
      }).observe(bar);
    }
    window.addEventListener("scroll", scheduleVisibility, { passive: true });
    window.addEventListener("resize", sync);
    requestAnimationFrame(sync);
  }

  function findFixedHost(element) {
    let current = element;
    while (current && current !== document.body) {
      const style = window.getComputedStyle(current);
      if (style.position === "fixed" || style.position === "sticky") {
        return current;
      }
      current = current.parentElement;
    }
    return element;
  }

  let floatingFramePending = false;

  function adjustFloatingWidgets() {
    if (!mobileQuery.matches || floatingFramePending) {
      return;
    }
    floatingFramePending = true;
    requestAnimationFrame(() => {
      floatingFramePending = false;
      positionFloatingWidgets();
    });
  }

  function positionFloatingWidgets() {
    if (!mobileQuery.matches) {
      return;
    }

    const hasProductBar = document.body.classList.contains("sk-mobile-product-bar-ready");
    const bottomOffset = hasProductBar ? 86 : 16;
    const widgets = [];
    // Read all geometry before changing any widget styles.
    document.querySelectorAll("iframe").forEach((iframe) => {
      const rect = iframe.getBoundingClientRect();
      const isSmallBottomWidget =
        rect.width > 0 &&
        rect.width <= 280 &&
        rect.height > 0 &&
        rect.height <= 220 &&
        rect.left < window.innerWidth * 0.7 &&
        rect.bottom > window.innerHeight - 150;

      if (!isSmallBottomWidget) {
        return;
      }

      const label = `${iframe.title || ""} ${iframe.name || ""} ${iframe.src || ""}`.toLowerCase();
      const likelyRewardsWidget =
        label.includes("point") ||
        label.includes("reward") ||
        label.includes("loyal") ||
        label.includes("sk") ||
        rect.left < 32;

      if (!likelyRewardsWidget) {
        return;
      }

      const host = findFixedHost(iframe);
      widgets.push({ host, iframe });
    });
    widgets.forEach(({ host, iframe }) => {
      if (!host.classList.contains("sk-mobile-floating-widget-wrap")) {
        host.classList.add("sk-mobile-floating-widget-wrap");
      }
      if (!iframe.classList.contains("sk-mobile-floating-widget")) {
        iframe.classList.add("sk-mobile-floating-widget");
      }
      const styles = {
        bottom: `${bottomOffset}px`,
        "transform-origin": "bottom left",
        transform: hasProductBar ? "scale(0.82)" : "scale(0.74)",
      };
      Object.entries(styles).forEach(([property, value]) => {
        if (host.style.getPropertyValue(property) !== value ||
            host.style.getPropertyPriority(property) !== "important") {
          host.style.setProperty(property, value, "important");
        }
      });
    });
  }

  ready(() => {
    initCollectionIntro();
    initProductBar();
    adjustFloatingWidgets();

    window.addEventListener("resize", adjustFloatingWidgets);
    window.setTimeout(adjustFloatingWidgets, 1000);
    window.setTimeout(adjustFloatingWidgets, 3000);
    document.addEventListener("load", (event) => {
      if (event.target.tagName === "IFRAME") adjustFloatingWidgets();
    }, true);

    const floatingObserver = new MutationObserver((records) => {
      // Product prices, reviews and unrelated content do not introduce widgets.
      const hasNewFrame = records.some((record) =>
        Array.from(record.addedNodes).some((node) =>
          node.nodeType === 1 && (node.matches("iframe") || node.querySelector("iframe")),
        ),
      );
      if (hasNewFrame) adjustFloatingWidgets();
    });
    floatingObserver.observe(document.body, { childList: true, subtree: true });
  });
})();
